import {CLStore} from 'common/src/redux/store';
import addOrUpdateNodeState, {
  AddOrUpdateNodeStateType,
} from '../../../../utils/addOrUpdateNodeState';
import {CAMPAIGN_NODE_ID} from 'common/src/components/CLCardsMap/CLCardsMap.config';
import {PromptToCardAgentStatus} from '../../../promptToCardAgent/promptToCardAgent';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import {
  DTConditionNode,
  DTCreativeNode,
  DTOptimizationNode,
  DTScheduleNode,
  DTWeightedNode,
  DTStoreNode,
  DTProductSelectionNode,
  ContentFeedNode,
} from 'common/src/modules/decisionTree/decisionTree.types';
import deleteCardFromState from '../cardStateStorage/deleteCardFromState';

/**
 * Tries to add or update the card (using API), and reports the results back to the calling agent
 * @param store - Redux store
 * @param cardFromState - The card from session storage which was setup by the standalone agent
 * @param cardId - Card ID
 * @param chainOfThoughts - Chain of thoughts
 * @returns - Tool result
 */
export default async function tryPatchingCardAndReportResults(
  store: CLStore,
  cardFromState:
    | DTCreativeNode
    | ContentFeedNode
    | DTOptimizationNode
    | DTScheduleNode
    | DTWeightedNode
    | DTConditionNode
    | DTStoreNode
    | DTProductSelectionNode,
  cardId: number,
  chainOfThoughts: string,
) {
  const isExistingCard = cardId > CAMPAIGN_NODE_ID;

  try {
    const resultCardId = await addOrUpdateNodeState(
      store,
      cardFromState,
      isExistingCard ? AddOrUpdateNodeStateType.Update : AddOrUpdateNodeStateType.Add,
    );

    const response = `${
      isExistingCard ? 'Updated' : 'Added'
    } Condition card with id ${resultCardId} successfully. Summary: ${chainOfThoughts}`;

    deleteCardFromState();

    return toolResult(response);
  } catch (error) {
    return toolResult(
      JSON.stringify({
        status: PromptToCardAgentStatus.NoAction,
        chainOfThoughts,
        error: error.message,
      }),
    );
  }
}
